module.exports = __webpack_public_path__ + "static/vinge-c7d16441c6ea99a7e04ee89c68a1377d.png";